<h1 matDialogTitle>{{'EVENTCONFIRM' | translate}}</h1>
<div mat-dialog-content>{{confirmMessage}}</div>
<mat-dialog-actions align="center">
  <button mat-stroked-button color="basic" (click)="dialogRef.close(false)">{{'EVENTCANCEL' | translate}}</button>
  <button mat-flat-button color="warn" (click)="dialogRef.close(true)">{{'EVENTYES' | translate}}</button>
</mat-dialog-actions>
